module.exports = __webpack_public_path__ + "static/media/externalLink.3a04ee84.svg";